(() => {
 const data = document.querySelector('#jg-category-map');
 if (!data) return;
 const categories = new Map(JSON.parse(data.textContent).map(p => [p.handle, p.category]));
 const links = [...document.querySelectorAll('[data-jg-category]')];
 function handle(card) {
  if (card.dataset.jgHandle) return card.dataset.jgHandle;
  const a = card.querySelector('a[href*="/products/"]');
  return a ? new URL(a.href).pathname.split('/products/')[1].split('/')[0] : '';
 }
 function filter(category) {
  if (category && !links.some(a => a.dataset.jgCategory === category)) category = '';
  for (const card of document.querySelectorAll('.jg-series__card,#product-grid>li')) {
   card.hidden = Boolean(category && categories.get(handle(card)) !== category);
  }
  for (const group of document.querySelectorAll('.jg-series__group')) group.hidden = !group.querySelector('.jg-series__card:not([hidden])');
  for (const link of links) link.setAttribute('aria-current', String(link.dataset.jgCategory === category));
  document.querySelector('[data-jg-category-status]').textContent = links.find(a => a.dataset.jgCategory === category)?.textContent.trim() || '';
  document.querySelector('[data-jg-category-empty]').hidden = !category || Boolean(document.querySelector('.jg-series__card:not([hidden]),#product-grid>li:not([hidden])'));
 }
 for (const link of links) link.addEventListener('click', event => {
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault(); const url = new URL(location.href);url.searchParams.set('jg_type',link.dataset.jgCategory);url.hash='jg-series-title';history.pushState(null,'',url);filter(link.dataset.jgCategory);document.querySelector('#jg-series-title').scrollIntoView({block:'start'});
 });
 document.querySelector('[data-jg-show-all]').addEventListener('click',()=>{const url=new URL(location.href);url.searchParams.delete('jg_type');history.pushState(null,'',url);filter('');});
 addEventListener('popstate',()=>filter(new URL(location.href).searchParams.get('jg_type')));
 filter(new URL(location.href).searchParams.get('jg_type'));
})();
